var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideDashDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49581 8.36119C4.77483 8.64021 5.22796 8.64021 5.50698 8.36119L9.0784 4.78976C9.35742 4.51074 9.35742 4.05762 9.0784 3.7786C8.79939 3.49958 8.34626 3.49958 8.06724 3.7786L5.00028 6.84556L1.93331 3.78083C1.6543 3.50181 1.20117 3.50181 0.922154 3.78083C0.643136 4.05985 0.643136 4.51297 0.922154 4.79199L4.49358 8.36342L4.49581 8.36119Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDashDown);
export default __webpack_public_path__ + "static/media/sideDashDown.fd1642eb43d1f9f2c798190d8d33d49a.svg";
export { ForwardRef as ReactComponent };